import createIcon from '../../createIcon';

/**
 * @component @name AirlineSeatLegroomNormal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDEyVjNIMi41VjEyQzIuNSAxNC43NiA0Ljc0IDE3IDcuNSAxN0gxMy41VjE1SDcuNUM1Ljg0IDE1IDQuNSAxMy42NiA0LjUgMTJaTTIwIDE4SDE4LjVWMTFDMTguNSA5LjkgMTcuNiA5IDE2LjUgOUgxMS41VjNINS41VjExQzUuNSAxMi42NSA2Ljg1IDE0IDguNSAxNEgxNS41VjIxSDIwQzIwLjgzIDIxIDIxLjUgMjAuMzMgMjEuNSAxOS41QzIxLjUgMTguNjcgMjAuODMgMTggMjAgMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirlineSeatLegroomNormal = createIcon('AirlineSeatLegroomNormal', [
  [
    'path',
    {
      d: 'M4.5 12V3H2.5V12C2.5 14.76 4.74 17 7.5 17H13.5V15H7.5C5.84 15 4.5 13.66 4.5 12ZM20 18H18.5V11C18.5 9.9 17.6 9 16.5 9H11.5V3H5.5V11C5.5 12.65 6.85 14 8.5 14H15.5V21H20C20.83 21 21.5 20.33 21.5 19.5C21.5 18.67 20.83 18 20 18Z',
      key: '17utds',
    },
  ],
]);

export default AirlineSeatLegroomNormal;
